import { render, staticRenderFns } from "./ThirdQuestion.vue?vue&type=template&id=e1d0e0f4&"
import script from "./ThirdQuestion.vue?vue&type=script&lang=js&"
export * from "./ThirdQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1d0e0f4')) {
      api.createRecord('e1d0e0f4', component.options)
    } else {
      api.reload('e1d0e0f4', component.options)
    }
    module.hot.accept("./ThirdQuestion.vue?vue&type=template&id=e1d0e0f4&", function () {
      api.rerender('e1d0e0f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/domains/TranferFAQ/ThirdQuestion.vue"
export default component.exports